import React from 'react';

const TRUST_LIST_URL = 'https://cred.digital.gob.es/espacios-de-datos/lista-de-confianza-de-espacios-de-datos';

export const TrustBadge = ({ variant = 'color', showText = false, compact = false, className = '' }) => {
  const logoSrc = variant === 'white'
    ? '/logos/lista-confianza/logo-edc-white.svg'
    : '/logos/lista-confianza/logo-edc-color.svg';

  return (
    <a
      href={TRUST_LIST_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Lista de Confianza de Espacios de Datos (se abre en una nueva pestaña)"
      data-testid={`trust-badge-${variant}${compact ? '-compact' : ''}`}
      className={`inline-flex flex-col items-center gap-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-link-blue rounded-lg transition-opacity hover:opacity-80 ${className}`}
    >
      <img
        src={logoSrc}
        alt="Lista de Confianza de Espacios de Datos"
        className={compact ? 'h-10 w-auto max-w-full' : 'h-16 sm:h-20 w-auto max-w-full'}
        loading="lazy"
      />
      {showText && (
        <span
          className={`text-center ${variant === 'white' ? 'text-slate-300' : 'text-slate-600'} ${compact ? 'text-xs' : 'text-sm'}`}
          data-testid="trust-badge-text"
        >
          Espacio de datos incluido en la Lista de Confianza de Espacios de Datos
        </span>
      )}
    </a>
  );
};

export default TrustBadge;
